// A client's contact people on the card (migration 071): the main one first and marked,
// each with a role or note, a phone and an email. Edited in place through the same
// editor the client and lead forms use, saved on its own (PUT /clients/:id/contacts) so
// nothing else about the client is sent with it.
import { useState } from 'react';
import { clientsApi } from '../../api';
import he from '../../i18n/he';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import { ErrorText } from '../../components/Loader';
import ContactsEditor from '../../components/ContactsEditor';
import { initialContacts, contactsPayload, contactsValid } from '../../utils/contacts';

const t = he.clients;

function ContactsModal({ client, onClose, onSaved }) {
  const [contacts, setContacts] = useState(() => initialContacts(client));
  const [error, setError] = useState(null);
  const submit = async () => {
    try {
      await clientsApi.setContacts(client.id, contactsPayload(contacts));
      onSaved();
    } catch (e) {
      setError(e);
    }
  };
  return (
    <Modal title={t.editContacts} onClose={onClose} onSave={submit} saveDisabled={!contactsValid(contacts)}>
      <ContactsEditor contacts={contacts} onChange={setContacts} />
      {error && <ErrorText error={error} />}
    </Modal>
  );
}

export default function ContactsCard({ client, onSaved }) {
  const [editing, setEditing] = useState(false);
  const list = client.contacts || [];
  return (
    <div className="card client-section">
      <div className="client-section-head">
        <h2>{t.contacts}</h2>
        <Button small variant="ghost" onClick={() => setEditing(true)}>{he.common.edit}</Button>
      </div>
      {list.length === 0 ? <p className="muted">{t.noContacts}</p> : (
        <ul className="client-contacts">
          {list.map((c) => (
            <li key={c.id} className="client-contact">
              <span className="client-contact-name">
                {c.name || c.phone || c.email}
                {c.is_main && <span className="badge blue">{t.mainContact}</span>}
              </span>
              {c.role && <span className="muted">{c.role}</span>}
              <span className="client-contact-ways">
                {c.phone && <span dir="ltr">{c.phone}</span>}
                {c.email && <span dir="ltr">{c.email}</span>}
              </span>
            </li>
          ))}
        </ul>
      )}
      {editing && (
        <ContactsModal
          client={client}
          onClose={() => setEditing(false)}
          onSaved={() => { setEditing(false); onSaved(); }}
        />
      )}
    </div>
  );
}
